import { createContext, useContext } from 'react';

import type { AppConfig } from '../types';

export const ConfigContext = createContext<AppConfig | null>(null);

export function useAppConfig(): AppConfig {
  const cfg = useContext(ConfigContext);
  if (!cfg) {
    throw new Error(
      'useAppConfig must be used inside <ConfigContext.Provider>',
    );
  }
  return cfg;
}

export function useGeographies() {
  return useAppConfig().geographies;
}

export function useTestTicketUrl(producerSysId: string | null | undefined): string | null {
  const cfg = useAppConfig();
  if (!producerSysId) return null;
  return `${cfg.servicenow_test_url}/ecportal?id=sc_cat_item&table=sc_cat_item&sys_id=${encodeURIComponent(producerSysId)}`;
}
